@import '../../packages/shared/scss';

:host {
  display: block;
  @include apply-themes();
  background-color: $pds-theme-light-primary;
  width: 100%;
  overflow: hidden;
  color: white;
  line-height: p-px-to-rem(20px);
  border-bottom: 1PX solid #E3E4E5;
  font-size: p-px-to-rem(12px);


  &.showing {
    animation: slideDown 1s ease-in-out 0s;
  }

  &.hiding {
    animation: slideUp 1s ease-in-out 0s;
  }

  @include pds-media-query-min('s') {
    font-size: p-px-to-rem(14px);
  }

  @include pds-media-query-min('xl') {
    font-size: p-px-to-rem(16px);
  }

  phn-p-button-pure, phn-p-link-pure {
    height: fit-content;
  }

  .country-recommender-container {
    @include pds-grid;



    font-family: $pds-font-family;
    font-weight: $pds-font-weight-regular;
    color: $pds-theme-light-background-base;

    .country-recommender {
      font-family: $pds-font-family;
      font-weight: $pds-font-weight-regular;
      color: $pds-theme-light-background-base;

      overflow: hidden;

      display: flex;
      align-items: center;
      position: relative;
      grid-column: wide-start/wide-end;
      @include limit-stretch();
      padding-top: p-px-to-rem(26px);
      padding-bottom: p-px-to-rem(10px);

      .country-recommender-icons-tray {
        display: grid;
        grid-template-columns: 4fr 1fr;
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-template-areas: "left  right";
        width: 100%;

        div.left-icons,
        div.right-icons {
          display: flex;
          flex-direction: row;
        }

        div.left-icons {
          grid-area: left;
          flex-wrap: wrap;
        }

        div.right-icons {
          display: flex;
          flex-direction: row;
          justify-self: end;
          grid-area: right;
        }


        .statement {
          order: 0;
          padding-top: p-px-to-rem(2px);
          padding-right: p-px-to-rem(8px);

          @include pds-media-query-max('s') {
            padding-bottom: p-px-to-rem(17px);
          }
          @include pds-media-query-max('xs') {
            padding-bottom: p-px-to-rem(17px);
          }
          @include pds-media-query-min-max('base', 'xs') {
           padding-bottom: p-px-to-rem(10px);
          }
        }

        .flag {
          margin-right: p-px-to-rem(8px);
          max-height: p-px-to-rem(24px);
          width: p-px-to-rem(20px);
          height: p-px-to-rem(20px);
          border-radius: 100%;
          border: 1px solid $pds-theme-light-contrast-medium;
          background-color: $pds-theme-light-contrast-medium;

          @include pds-media-query-min('m') {
            width: p-px-to-rem(22px);
            height: p-px-to-rem(22px);
          }
        }

        .flag-region {
          display: flex;
        }

        .language {
          padding-right: p-px-to-rem(24px);
          padding-top: p-px-to-rem(2px);
          padding-bottom: p-px-to-rem(16px);
        }

        .selector {
          display: inline-flex;
          order: 2;
          width: 100%;

          @include pds-media-query-min('s') {
            order: 1;
            width: auto;
          }
        }

        .change {
          padding-top: p-px-to-rem(2px);
          margin-bottom: p-px-to-rem(16px);
        }

        .close-button {
          grid-area: right;
          margin-left: auto;
          order: 1;
          font-size: p-px-to-rem(6px);

          @include pds-media-query-min('s') {
            order: 2;
          }
        }
      }
    }
  }
}


